import React from 'react';

function PlusCircleSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.47732 2 2 6.47732 2 12C2 17.5227 6.47732 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47732 17.5227 2 12 2ZM12 7.625C12.3138 7.625 12.5736 7.85626 12.6182 8.15764L12.625 8.25V11.375H15.75C16.0952 11.375 16.375 11.6548 16.375 12C16.375 12.3138 16.1437 12.5736 15.8424 12.6182L15.75 12.625H12.625V15.75C12.625 16.0952 12.3452 16.375 12 16.375C11.6862 16.375 11.4264 16.1437 11.3818 15.8424L11.375 15.75V12.625H8.25C7.90482 12.625 7.625 12.3452 7.625 12C7.625 11.6862 7.85626 11.4264 8.15764 11.3818L8.25 11.375H11.375V8.25C11.375 7.90482 11.6548 7.625 12 7.625Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default PlusCircleSolid;
